import React from 'react'
import Jumbotron from '../../Component/Jumbotron'
import styled from 'styled-components'

import Dev from '../../assets/projetos/dev.png'
import Mexico from '../../assets/projetos/mexico.png'
import Mercedez from '../../assets/projetos/mercedez.png'
import Docs from '../../assets/projetos/docs.png'
import Robot from '../../assets/projetos/robot.png'
import Trader from '../../assets/projetos/trader.png'
import Bruna from '../../assets/projetos/bruna.png'
import Ficheiro from '../../assets/projetos/ficheiro.png'
import Paint from '../../assets/projetos/paint.png'
import Port01 from '../../assets/projetos/port01.png'
import Surf from '../../assets/projetos/surf.png'
import Audrey from '../../assets/projetos/audrey.png'
import Blog from '../../assets/projetos/blog.png'
import Dashboard from '../../assets/projetos/dashboard.png'
import Flashcard from '../../assets/projetos/flashcard.png'
import Lits from '../../assets/projetos/lits.png'
import Morse from '../../assets/projetos/morse.png'
import Nefro01 from '../../assets/projetos/nefro01.png'
// import Nefro02 from '../../assets/projetos/nefro02.png'
import Port02 from '../../assets/projetos/port02.png'
import Port03 from '../../assets/projetos/port03.png'
import Renale from '../../assets/projetos/renale.png'
import Smv from '../../assets/projetos/smv.png'
import React01 from '../../assets/projetos/react01.png'
import Wisefi from '../../assets/projetos/wisefi.png'


import { Card, Row, Col, Typography } from 'antd';

const { Meta } = Card;
const { Paragraph } = Typography;


const Projetos = () => {

    const projetos = [
        {
            id: 1,
            title: "DevImprove",
            img: Dev,
            description: 'Se desafie a cada dia. O site tem por finalidade sanar um grande problema para desenvolvedores iniciantes, seu portfolio. O site dispoe diversos desafios dentre as areas Frontend, Backend e Mobile para os devs escolherem e praticarem seus conhecimentos e assim aos poucos aumentar seus respectivos portfolios.',
            tag: 'HTML, CSS',
        },   
        {
            id: 2,
            title: "Mexican Tourism",
            img: Mexico,
            description: 'Site com feito com o intuito de praticar meus conhecimentos como desenvolvedor Frontend, seu desenvolvimento foi baseado nos mesmos princípios de frameworks modernos como React, Vue ou Angular de Single Page Application (SPA).',
            tag: 'HTML, CSS',
        },
        {
            id: 24,
            title: "Wisefi",
            img: Wisefi,
            description: 'Projeto de parceria entre UFRN e Intelbras, desenvolvimento do frontend da plataforma Wisefi para melhorias e atualização da tecnologia usada e adição de internacionalização.',
            tag: 'HTML, CSS',
        },
        {
            id: 3,
            title: "Mercedes",
            img: Mercedez,
            description: 'Site com feito com o intuito de praticar meus conhecimentos como desenvolvedor Frontend, beaseado em protótipo encontrado na internet, a ideia era me desafiar a criar algo que estava apenas feito em design.',
            tag: 'HTML, CSS',
        },
        {
            id: 4,
            title: "Lion Forex Robot",
            img: Robot,
            description: 'Site desenvolvido para empresa especializada na criação e manutenção de robos automatizados para trading',
            tag: 'HTML, CSS',
        },
        {
            id: 5,
            title: "QuarkDocs",
            img: Docs,
            description: 'Plataforma desenvolvida pela empresa ESIG, nesse projeto em questão meu trabalho foi iniciar o desenvolvimento da plataforma utilizando tecnologias mais recentes, para o caso foi usado o Angular2+ para seu desenvolvimento.',
            tag: 'HTML, CSS',
        },   
        {
            id: 6,
            title: "Bruna's Portfolio",
            img: Bruna,
            description: 'Criação de portfolio para colega com o intuito de treinar meus conhecimentos no desenvolvimento web, design próprio',
            tag: 'HTML, CSS',
        },
        {
            id: 7,
            title: "Paint Enterprise Portfolio",
            img: Paint,
            description: 'Template de website para empresa de pintura desenvolvido com intuito de estudar e aplicar meus conhecimentos em VueJs, design próprio',
            tag: 'HTML, CSS',
        },
        {
            id: 8,
            title: "Old Portfolio",
            img: Port01,
            description: 'Template de portfolio criado e usado por mim durante certo período da carreira, design próprio',
            tag: 'HTML, CSS',
        },
        {
            id: 9,
            title: "File Based Website",
            img: Ficheiro,
            description: 'Website desenvolvido para treino e aplicação dos conhecimentos com VueJs tem por intuito parecer um ficheiro incluido as interações entre as abas, design próprio que surgiu por acaso.',
            tag: 'HTML, CSS',
        },   
        {
            id: 10,
            title: "Simple Dashboard",
            img: Dashboard,
            description: 'Página desenvolvida a partir de um wireframe como teste para vaga de estágio como desenvolvedor Frontend em empresa de tecnologia de Natal',
            tag: 'HTML, CSS',
        },
        {
            id: 11,
            title: "Audrey's Portfolio",
            img: Audrey,
            description: 'Criação de portfolio para colega com o intuito de treinar meus conhecimentos no desenvolvimento web',
            tag: 'HTML, CSS',
        },
        {
            id: 12,
            title: "Lion Forex Trader",
            img: Trader,
            description: 'Site desenvolvido para empresa especializada na manutenção de servidores rodando robos de trading com fins de ShareProfit',
            tag: 'HTML, CSS',
        },
        {
            id: 13,
            title: "Renale Clinic",
            img: Renale,
            description: 'Website desenvolvido como projeto final da disciplina de desenvolvimento Web I, onde apliquei os conheimentos adquiridos em site para clínica de nefrologia de Natal chamada Renale',
            tag: 'HTML, CSS',
        },   
        {
            id: 14,
            title: "Phone Based Portfolio",
            img: Port02,
            description: 'Website simples usado como portfolio durante certo período, sua navegação é baseada em um telefone feito com CSS. Projeto desenvolvido para treinar e aplicar conhecimentos em VueJs, design próprio.',
            tag: 'HTML, CSS',
        },
        {
            id: 15,
            title: "Flashcard System",
            img: Flashcard,
            description: 'Site de administração de cards de tarefas ou lembretes desenvolvido como forma de me desafiar com o uso dinâmico do JS na manutenção das informações em display na tela, assim como o uso de abas como forma de navegação entre informações extras.',
            tag: 'HTML, CSS',
        },
        {
            id: 16,
            title: "Surf Style Portfolio",
            img: Surf,
            description: 'Template de website desenvolvido pra treinar e aplicar conhecimentos de desenvolvimento web como posicionamentos e estilos assim como uso de frameworks e bibliotecas',
            tag: 'HTML, CSS',
        },
        {
            id: 17,
            title: "Morse Code Translator",
            img: Morse,
            description: 'Projeto inicialmente desenvolvido em C++ como projeto da faculdade e posteriormente transformado em página web para ter acesso simplificado, depois foi adicionado a função para traduzir textos em morse.',
            tag: 'HTML, CSS',
        },   
        {
            id: 18,
            title: "Lits",
            img: Lits,
            description: 'Website desenvolvido para laboratório de pesquisa da UFRN onde mostra os projetos em desenvolvimento por ele assim como suas descrições. Site desenvolvido para treino e aplicação de conhecimentos do framework VueJs',
            tag: 'HTML, CSS',
        },
        {
            id: 19,
            title: "Smv",
            img: Smv,
            description: 'Simulador de memória virtual, projeto desenvolvido para simular como ocorre a ocupação da memória do computador desenvolvido em Angular2+ e Typescript para retornar estatísticas de qual é o método mais eficiente para popular a memória.',
            tag: 'HTML, CSS',
        },
        {
            id: 20,
            title: "Simple React App",
            img: React01,
            description: 'Site desenvolvido para treino e aplicação de conhecimentos com react seguindo tutorias da empresa Rocketseat.',
            tag: 'HTML, CSS',
        },
        {
            id: 21,
            title: "Nefroatlas",
            img: Nefro01,
            description: 'Plataforma educacional para estudantes e profissionais da área de medicina que querem se especializar em nefrologia. Desenvolvimento de landingpage e dashboard. Projeto posteriormente apresentado na Engineeringg in Medicine and Biology Conference (EMBC2019), sediada em Berlim - Alemanha',
            tag: 'HTML, CSS',
        },
        {
            id: 22,
            title: "Blog Dashboard",
            img: Blog,
            description: 'Dashboard desenvolvida para usuários de API criada por mim para manutenção e administração de Posts de forma centralizada.',
            tag: 'HTML, CSS',
        },
        {
            id: 23,
            title: "Port 03",
            img: Port03,
            description: 'Template de portfolio utilizado por mim em algum momento, desenvolvido para treino de conhecimentos adquiridos e atualização de informações.',
            tag: 'HTML, CSS',
        },
    
    ]


    return (
        <>
            <Jumbotron height={40} message={'Projetos'}/>

            <Row justify='center' style={{padding: '40px 0', width: '100%'}}>
                {projetos.map(item=> {
                    return(
                        <Col xs={23} sm={23} md={10} lg={6} xl={6} style={{margin: '20px'}}>
                            <Card
                                style={{ width: '100%', 
                                        minHeight: '300px',
                                        borderRadius: '5px'
                                     }}
                                cover={<img src={item.img} alt={item.title} width={'100%'} style={{position: 'relative', zIndex: '2', borderRadius: '5px'}}/>}
                            >
                                <Meta
                                    className='customScroll'
                                    style={{height: '135px', overflow: 'auto'}} 
                                    title={<H2>{item.title}</H2>} 
                                    description={
                                    <>
                                        <Paragraph ellipsis={{rows: 3, expandable: true}}>
                                            {item.description}
                                        </Paragraph>
                                    </>
                                } />
                                <div style={{padding: '20px 0 0 0'}}>
                                    {item.tag}
                                </div>
                            </Card>
                        </Col>
                    )
                })}
            </Row>
        </>
    )
}

export default Projetos


const H2 = styled.h2`
    margin: 0;
`
